export const formatInstallmentText = (installment: number) => {
  return installment === 1 ? '1 parcela' : `${installment} parcelas`
}
